export default "__VITE_ASSET__fcc2b4f0__"